
import React from "react";
import { FormField, FormItem, FormLabel, FormControl } from "@/components/ui/form";
import { Switch } from "@/components/ui/switch";
import { UseFormReturn } from "react-hook-form";

interface TerraceFeatureProps {
  form: UseFormReturn<any>;
}

const TerraceFeatures = ({ form }: TerraceFeatureProps) => {
  return (
    <div className="space-y-4">
      <div className="text-sm font-medium text-sunset-dark mb-3">Business Features</div>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-y-3 gap-x-5">
        <FormField
          control={form.control}
          name="hasFood"
          render={({ field }) => (
            <FormItem className="flex items-center justify-between space-x-2">
              <FormLabel>Serves Food</FormLabel>
              <FormControl>
                <Switch
                  checked={field.value}
                  onCheckedChange={field.onChange}
                />
              </FormControl>
            </FormItem>
          )}
        />
        
        <FormField
          control={form.control}
          name="servesAlcohol"
          render={({ field }) => (
            <FormItem className="flex items-center justify-between space-x-2">
              <FormLabel>Serves Alcohol</FormLabel>
              <FormControl>
                <Switch
                  checked={field.value}
                  onCheckedChange={field.onChange}
                />
              </FormControl>
            </FormItem>
          )}
        />
        
        <FormField
          control={form.control}
          name="servesWine"
          render={({ field }) => (
            <FormItem className="flex items-center justify-between space-x-2">
              <FormLabel>Serves Wine</FormLabel>
              <FormControl>
                <Switch
                  checked={field.value}
                  onCheckedChange={field.onChange}
                />
              </FormControl>
            </FormItem>
          )}
        />
        
        <FormField
          control={form.control}
          name="servesBeer"
          render={({ field }) => (
            <FormItem className="flex items-center justify-between space-x-2">
              <FormLabel>Serves Beer</FormLabel>
              <FormControl>
                <Switch
                  checked={field.value}
                  onCheckedChange={field.onChange}
                />
              </FormControl>
            </FormItem>
          )}
        />
        
        <FormField
          control={form.control}
          name="allowsDogs"
          render={({ field }) => (
            <FormItem className="flex items-center justify-between space-x-2">
              <FormLabel>Dog Friendly</FormLabel>
              <FormControl>
                <Switch
                  checked={field.value}
                  onCheckedChange={field.onChange}
                />
              </FormControl>
            </FormItem>
          )}
        />
        
        <FormField
          control={form.control}
          name="wheelchairAccessible"
          render={({ field }) => (
            <FormItem className="flex items-center justify-between space-x-2">
              <FormLabel>Wheelchair Accessible</FormLabel>
              <FormControl>
                <Switch
                  checked={field.value}
                  onCheckedChange={field.onChange}
                />
              </FormControl>
            </FormItem>
          )}
        />
      </div>
    </div>
  );
};

export default TerraceFeatures;
